import { Component, OnInit } from '@angular/core';
import { UserImageModel } from '@core/api';
import { UserService } from '@accounts/user/services/user.service';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { finalize } from 'rxjs/operators';
import { FormBuilder, FormGroup } from '@angular/forms';
import { HttpStatusCode } from '@core/enums/http-status-code';
import { FormService } from '@core/services';

@Component({
  selector: 'user-driving-license',
  templateUrl: './user-driving-license.component.html',
  styleUrls: ['./user-driving-license.component.scss']
})
export class UserDrivingLicenseComponent implements OnInit {

  allowedTypes = [
    {
      type: UserImageModel.TypeEnum.DriverLicenseFront,
      label: this.i18n('Фото ВУ')
    },
    {
      type: UserImageModel.TypeEnum.DriverLicenseBack,
      label: this.i18n('Фото ВУ (обр. сторона)')
    }
  ];

  imageTypes: typeof UserImageModel.TypeEnum;

  form: FormGroup = this.formBuilder.group({
    [UserImageModel.TypeEnum.DriverLicenseFront]: [null],
    [UserImageModel.TypeEnum.DriverLicenseBack]: [null]
  });

  constructor(
    private formBuilder: FormBuilder,
    private formService: FormService,
    private userService: UserService,
    private i18n: I18n
  ) {
    this.imageTypes = UserImageModel.TypeEnum;
  }

  selectFile({ image, type, start, stop }) {
    start();

    this.form.get(type).setValue(image);

    this.userService.uploadImage({
      image,
      type
    })
      .pipe(finalize(stop))
      .subscribe(res => {
        stop();
      }, error => {
        if (error.status === HttpStatusCode.UNPROCESSABLE_ENTITY) {

          error.errors[type] = error.errors && error.errors.image;

          this.formService.serverValidateForm(this.form, error);
        }
      });
  }

  ngOnInit() {
    this.userService.getImages();
  }

}
